import axios from '../common/js/axios'
import { host } from '../common/js/config'

/*我的课程*/
export function getCourse(data){
	const url = `${host}/ajax/my/course`
	return axios({
		url: url,
		params: data
	})
}

/*系统消息*/
export function getLetter(data){
	const url = `${host}/app/user/letter`
	return axios({
		url: url,
		params: data
	})
}

//获取学习信息
export function getStudy(data){
	const url = `${host}/app/uc/study`
	return axios({
		url: url,
		params: data
	})
}


//意见反馈
export function putSuggest(data) {
	const url = `${host}/app/feedback/add`
	return axios({
		url: url,
		params: data
	})
}

//我的收藏
export function getCollect(data) {
	const url = `${host}/app/uc/fav`
	//const url = `${host}/app/collection/list`
	return axios({
		url: url,
		params: data
	})
}


//统计
export function addRecord(data) {
	const url = `${host}/app/user/addUserUsageOpRecord`
	//const url = `${host}/app/collection/list`
	return axios({
		url: url,
		params: data
	})
}

//收货地址
export function getAddress(data){
	const url = `${host}/app/userAddress/list`
	return axios({
		url: url,
		params: data
	})
}

//收货地址更新 
export function updateAddress(data){
	const url = `${host}/app/userAddress/update`
	return axios({
		url: url,
		params: data
	})
}
//添加收货地址 
export function addAddress(data){
	const url = `${host}/app/userAddress/add`
	return axios({
		url: url,
		params: data
	})
}
//删除收货地址 /app/userAddress/del
export function deleteAddress(data){
	const url = `${host}/app/userAddress/del`
	return axios({
		url: url,
		params: data
	})
}

// 设置为默认 /app/userAddress/setFirst
export function setDefault(data){
	const url = `${host}/app/userAddress/setFirst`
	return axios({
		url: url,
		params: data
	})
}

// 收益 
export function earnings(data){
	const url = `${host}/app/user/acc`
	return axios({
		url: url,
		params: data
	})
}

//收入列表
export function distributionlist(data) {
	const url = `${host}/app/order/distributionlist`
	return axios({
		url: url,
		params: data
	})
}

//绑定支付宝 银行卡
export function bindcard(data) {
	const url = `${host}/app/withdraw/editUserAccount`
	return axios({
		url: url,
		params: data
	})
}

//提现申请表
export function applywidth(data) {
	const url = `${host}/app/withdraw/showWithdrawTable`
	return axios({
		url: url,
		params: data
	})
}

//提交提现
export function submitwidth(data) {
	const url = `${host}/app/withdraw/submit`
	return axios({
		url: url,
		params: data
	})
}

//支付查询
 export function withdrawInfo(data) {
	const url = `${host}/app/withdraw/queryInfo`
	return axios({
		url: url,
		params: data
	})
 }

 //银行列表
 export function wxBankList(data) {
	const url = `${host}/app/wxBank/list`
	return axios({
		url: url,
		params: data
	})
 }
//修改信息
 export function updateInfo(data) {
	const url = `${host}/app/user/update/info`
	return axios({
		url: url,
		params: data
	})
 }


// WEBPACK FOOTER //
// ./src/api/my.js